import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import user from '../images/ic_account_circle.png';

import { formatDateOfBirth } from '../util/util'

const UserCard = (props) => {
    const classes = useStyles();
    const name = "Jane Doe";
    const birthdate="Jan 1, 1990";
    return (
        <div className="user-banner">
            <div className="citizenName">
            <div class="userIcon"><img src={user} width="40" /></div>
            <h6>{props.user.firstName + " " + props.user.lastName}</h6></div>
            <p class="dob">{formatDateOfBirth(props.user.dateOfBirth, props.language)}<br />
            </p>
        </div>
    );
}

export default UserCard;

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        minWidth: 275
    },
    pos: {
        marginBottom: 12
    },
    paper: {
        padding: theme.spacing(2),
        margin: "auto",
        maxWidth: 275
    },
    icon: {
        fontSize: 50
    }
}));
